var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5763 8.18359L13.7638 9.95394L9.83675 13.7526L8.55591 12.5098L11.178 9.95394H0.423828V8.18359H15.5763Z",
    fill: "#A18E77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.423828 5.81604L2.24841 4.04569L6.16341 0.24707L7.44424 1.48983L4.82216 4.04569H15.5763V5.81604H0.423828Z",
    fill: "#A18E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/Change-icon.faee2cb26dc708e3e12eee6dd76fa04b.svg";
export { ForwardRef as ReactComponent };